import React, { Component } from 'react';
import BreadCrumb from './breadcrumb';
import {
    Checkbox,
    FormControl,
    InputLabel,
    MenuItem,
    Select,    
    TextField   
} from '@mui/material';

class SearchMenu extends Component {
    constructor(props) {
        super(props);
        this.state = { UniqueQcRuns: [], selectedQcRuns: [] };
    }

    componentDidMount() {
        this.setState({
            ResultStatus: this.props.uniqueQcRuns.length > 0 ? this.props.uniqueQcRuns[0] : 'All',
            status: '',
            selectedQcRuns: [],
            UniqueQcRuns: this.props.uniqueQcRuns   
        });
        console.log('uniqueQcRuns', this.props.uniqueQcRuns);
    }

    handleQcRunChange = (event) => {
        const { value } = event.target;
        const { uniqueQcRuns } = this.props;
        const { selectedQcRuns } = this.state;

        // Detect "All" selection
        if (value.includes("all")) {
            if (selectedQcRuns.length === uniqueQcRuns.length) {
                // 🔹 Already all selected → clear all
                this.setState({ selectedQcRuns: [] }, () => {
                    this.props.onQcRunChange?.([]);
                });
            } else {
                // 🔹 Select all
                this.setState({ selectedQcRuns: uniqueQcRuns }, () => {
                    this.props.onQcRunChange?.(uniqueQcRuns);
                });
            }
        } else {
            // 🔹 Regular individual selection
            this.setState({ selectedQcRuns: value }, () => {
                this.props.onQcRunChange?.(value);
            });
        }
    };

 

    render() {
        return (
            <div>
                <BreadCrumb />
                <div className="row" style={{ padding: '12px' }}>
                    <div className="col-md-3">
                        <TextField
                            label="Current Grid Search"
                            variant="outlined"
                            id="reset-form"
                            InputLabelProps={{
                                shrink: true
                            }}
                            type="string"
                            margin="dense"
                            onChange={this.props.onFilterTextChange}
                        />
                    </div>
                    <div className="col-md-3" style={{ padding: '12px', marginTop: '-10px' }}>
                        <FormControl variant="outlined" className="filter-select-bar">
                            <InputLabel id="qc-run-label">Select QC Run</InputLabel>
                            <Select
                                labelId="qc-run-label"
                                id="qc-run-select"
                                multiple
                                value={this.state.selectedQcRuns}
                                onChange={this.handleQcRunChange} // ✅ don’t destructure target.value here
                                label="Select QC Run"
                                renderValue={(selected) =>
                                    selected.length === this.props.uniqueQcRuns.length
                                        ? "All QC Runs"
                                        : selected.join(", ")
                                }
                            >
                                {/* "All" Option */}
                                <MenuItem key="all" value="all">
                                    <Checkbox
                                        checked={
                                            this.state.selectedQcRuns.length === this.props.uniqueQcRuns.length
                                        }
                                    />
                                    All QC Runs
                                </MenuItem>

                                {/* Individual QC Runs */}
                                {this.props.uniqueQcRuns.map((qcRun) => (
                                    <MenuItem key={qcRun} value={qcRun}>
                                        <Checkbox checked={this.state.selectedQcRuns.includes(qcRun)} />
                                        {qcRun}
                                    </MenuItem>
                                ))}
                            </Select>

                        </FormControl>

                    </div>
                    <div className="col-md-6">
                        <div className="d-flex justify-content-between align-items-center" style={{ gap: '8px' }}>
                            <div>
                                <button
                                    className="btn btn-primary button-info-grid me-2"
                                    onClick={() => this.props.clearFilter()}
                                >
                                    <i className="fa fa-times" aria-hidden="true"></i> Clear Filter
                                </button>

                                <button
                                    className="btn btn-info  button-info-grid"
                                    // onClick={() => this.props.saveState()}
                                    onClick={() => this.props.onReviewClick()}
                                >
                                    <i className="far fa-save"></i> Update Status
                                </button>
                            </div>
                            <div>
                                <button
                                    className="btn btn-primary button-info-grid"
                                    onClick={() => this.props.onBtnExport()}
                                >
                                    <i className="fa fa-file-excel-o" aria-hidden="true"></i> Export
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SearchMenu;
